import React, { useRef, useState, useContext, useEffect, useLayoutEffect } from 'react';

import bgVideo from './../assets/videos/methodischdidactisch_bg.mp4';
import setFullscreenVideoAspectRatio from '../helpers/VideoHelper';

import { MethodischDidactischContext } from '../components/MethodischDidactischLayoutWrapper';
import TrajectSelectModal from '../components/TrajectSelectModal';
import MethodischDidactischListCard from '../components/MethodischDidactischListCard';

function PageMethodischDidactisch() {
    const methodischDidactischContext = useContext(MethodischDidactischContext);

    const videoEl = useRef(null);
    const [showKlasSelectModal, setShowKlasSelectModal] = useState(true);
    const [activeHoverTitle, setActiveHoverTitle] = useState('');
    const [activeRootOverlay, setActiveRootOverlay] = useState(0);
    const [videoLoaded, setVideoLoaded] = useState(false);
    const currentCardsFiltered = getCurrentCardsArrayFiltered();

    function resize() {
        if (videoEl.current === null) return;
        setFullscreenVideoAspectRatio(videoEl.current, 16 / 9);
    }
    resize();

    useLayoutEffect(() => {
        if (videoEl.current === null) return;

        resize();
        window.addEventListener('resize', resize);

        const interval = setInterval(() => {
            if (videoEl.current.currentTime > 3) setVideoLoaded(true);
            if (videoEl.current.currentTime > 5.8) {
                videoEl.current.pause();
                setVideoLoaded(true);
            }
        }, 50);

        return () => {
            clearInterval(interval);
            window.removeEventListener('resize', resize);
        };
    }, []);

    useEffect(() => {
        if (activeHoverTitle === '' && methodischDidactischContext.activeMotivatie === null) {
            setActiveRootOverlay(null);
            return;
        }

        if (methodischDidactischContext.activeMotivatie !== null) {
            setActiveRootOverlay(methodischDidactischContext.motivaties.findIndex(motivatie => motivatie.slug === methodischDidactischContext.activeMotivatie));
            return;
        }

        if (activeHoverTitle !== '') {
            const motivatieIndex = methodischDidactischContext.motivaties.findIndex(motivatie => motivatie.name === activeHoverTitle);
            setActiveRootOverlay(motivatieIndex);
        }

        return;
    }, [activeHoverTitle, methodischDidactischContext.activeMotivatie, methodischDidactischContext.motivaties]);

    useEffect(() => {
        if (methodischDidactischContext.activeKlas !== null) {
            videoEl.current.play();
        }
        else {
            setVideoLoaded(false);

            videoEl.current.pause();
            videoEl.current.currentTime = 0;
        }
        setShowKlasSelectModal(methodischDidactischContext.activeKlas === null);
    }, [methodischDidactischContext.activeKlas]);

    function getCurrentCardsArrayFiltered() {
        if (typeof methodischDidactischContext.cards === 'undefined' || methodischDidactischContext.cards.length === 0) return [];
        if (methodischDidactischContext.activeKlas === null) return [];

        return methodischDidactischContext.cards.filter(card => {
            let containsKlas = false;
            card.klassen.forEach(klas => { if (klas.slug === methodischDidactischContext.activeKlas) containsKlas = true; });
            if (!containsKlas) return false;

            if (methodischDidactischContext.activeVak !== null) {
                let containsVak = false;
                card.vakken.forEach(vak => { if (vak.slug === methodischDidactischContext.activeVak) containsVak = true; });
                if (!containsVak) return false;
            }

            if (methodischDidactischContext.activeMotivatie !== null) {
                let containsMotivatie = false;
                card.motivaties.forEach(motivatie => { if (motivatie.slug === methodischDidactischContext.activeMotivatie) containsMotivatie = true; });
                if (!containsMotivatie) return false;
            }

            if (methodischDidactischContext.activeVerwerking !== null) {
                let containsVerwerking = false;
                card.verwerkingen.forEach(verwerking => { if (verwerking.slug === methodischDidactischContext.activeVerwerking) containsVerwerking = true; });
                if (!containsVerwerking) return false;
            }

            return true;
        });
    }

    function klasSelected(klasSlug) {
        methodischDidactischContext.setActiveKlas(klasSlug);
        setShowKlasSelectModal(false);
    }

    return (<>
        <div className="methodisch-didactisch">
            <div className="methodisch-didactisch__bg-wrapper">
                <video ref={videoEl} src={bgVideo} type="video/mp4" playsInline muted></video>

                {methodischDidactischContext.activeKlas !== null && <>
                    <div className={`methodisch-didactisch__root-overlay${videoLoaded ? ' video-loaded' : ''}`}>
                        <div className={'first' + (activeRootOverlay === 0 ? ' active' : '')}></div>
                        <div className={'second' + (activeRootOverlay === 1 ? ' active' : '')}></div>
                        <div className={'third' + (activeRootOverlay === 2 ? ' active' : '')}></div>
                    </div>
                </> }
            </div>

            {((videoLoaded && methodischDidactischContext.activeMotivatie === null && methodischDidactischContext.activeVak === null && methodischDidactischContext.activeVerwerking === null) && typeof methodischDidactischContext.motivaties !== 'undefined' && methodischDidactischContext.motivaties.length > 0) && <>
                <div className="methodisch-didactisch__motivaties">
                    {methodischDidactischContext.motivaties.slice(0, 3).map((motivatie, index) => { return (<button type="button" className="methodisch-didactisch__motivatie" key={Math.random() + Math.random() + ''} onClick={() => methodischDidactischContext.setActiveMotivatie(motivatie.slug)} onMouseOver={() => setActiveHoverTitle(motivatie.name) }></button>); })}
                    {methodischDidactischContext.activeKlas !== null && <span className="methodisch-didactisch__hover-title">{activeHoverTitle}</span>}
                </div>
            </>}

            {methodischDidactischContext.activeKlas !== null && (methodischDidactischContext.activeMotivatie !== null || methodischDidactischContext.activeVak !== null || methodischDidactischContext.activeVerwerking !== null) && <>
                {currentCardsFiltered.length === 0 && <div className="page-vak__no-cards-msg">Er zijn geen resultaten gevonden voor de huidige filtercombinatie.</div>}

                {currentCardsFiltered.length > 0 && <>
                    <ul className="page-vak__card-grid">
                        {currentCardsFiltered.map((card, index) => {
                            return (<MethodischDidactischListCard key={`page-md-grid-card-${index}`} card={card} showThumbnail={false} />);
                        })}
                    </ul>
                </>}
            </>}

            <TrajectSelectModal show={showKlasSelectModal} setShow={setShowKlasSelectModal} title="Kies een klas:" options={Object.values(methodischDidactischContext.klassen).map(klas => { return { title: klas.slug, slug: klas.slug } })} callback={klasSelected} />
        </div>
    </>);
}

export default PageMethodischDidactisch;
